import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { ReOpenSurveyRPC } from "./reOpenSurveyRPC";

export class ReOpenSurveyRPCClientImpl extends ReOpenSurveyRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: ReOpenSurveyRPC.Request): Promise<LeoRPCResult<ReOpenSurveyRPC.Response, ReOpenSurveyRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey/ReOpenSurvey",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      ReOpenSurveyRPC.ResponseDTO,
      ReOpenSurveyRPC.Errors.ErrorsDTO,
      ReOpenSurveyRPC.Response,
      ReOpenSurveyRPC.Errors.Errors
    >(
      response,
      "survey/ReOpenSurvey",
      ReOpenSurveyRPC.Response.fromDTO,
      ReOpenSurveyRPC.Errors.fromDTO
    );
  }
}
